const useCalcualatorAIScore = (score?: number | string) => {
  if (score === undefined || score === null) {
    return {
      color: 'gray',
      scoreLabel: '',
    };
  }
  if (Number(score) > 84) {
    return {
      color: 'purple',
      scoreLabel: `${score} (High Quality)`,
      quality: 'High Quality',
    };
  }
  if (Number(score) >= 60) {
    return {
      color: 'green',
      scoreLabel: `${score} (Moderate Quality)`,
      quality: 'Moderate Quality',
    };
  }
  if (Number(score) > 40) {
    return {
      color: 'volcano',
      scoreLabel: `${score} (Low Quality)`,
      quality: 'Low Quality',
    };
  }
  return {
    color: 'red',
    scoreLabel: `${score ?? ''} (Poor Quality)`,
    quality: 'Poor Quality',
  };
};

export default useCalcualatorAIScore;
